import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-terms-of-use',
	templateUrl: 'terms-of-use.html',
	styleUrls: [ 'terms-of-use.scss' ]
})
export class TermsOfUseComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}
}
